export enum FilterDefinitionType {
  Date = 'date',
  DateTime = 'date_time',
  Text = 'text',
  Enum = 'enum',
  User = 'user',
  Shop = 'shop',
  ShopGroup = 'shop_group',
  OrderStatus = 'order_status',
  Trader = 'trader',
  Merchant = 'merchant',
  Bank = 'bank',
  Select = 'select',
  MultiSelect = 'multi_select',
  Operator = 'operator',
  Numeric = 'numeric',
  Range = 'range',
  DateRange = 'date_range',
  DateTimeRange = 'date_time_range',
  TextArea = 'text_area',
}
